module.exports = __webpack_public_path__ + "static/img/101681.b5df5328.png";